import { render, staticRenderFns } from "./GiftItem.vue?vue&type=template&id=3aa925f3&"
import script from "./GiftItem.vue?vue&type=script&lang=js&"
export * from "./GiftItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Projekte/woerner-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aa925f3')) {
      api.createRecord('3aa925f3', component.options)
    } else {
      api.reload('3aa925f3', component.options)
    }
    module.hot.accept("./GiftItem.vue?vue&type=template&id=3aa925f3&", function () {
      api.rerender('3aa925f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/GiftItem.vue"
export default component.exports